/* eslint-disable max-classes-per-file */
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 * Fires when the user expands the service area map in the revamp sitter profile gallery.
 *
 * &nbsp;
 */
export class SitterGalleryLocationExpandEvent extends AnalyticsEvent {
  eventName = 'sitter-gallery-location-expand';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.provider_profile;
}

/**
 * &nbsp;
 *
 * # Description
 * Fires when the user clicks the ratings/reviews card in the revamp sitter profile gallery.
 *
 * &nbsp;
 */
export class SitterGalleryReviewCardClickedEvent extends AnalyticsEvent {
  eventName = 'sitter-gallery-review-card-clicked';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.provider_profile;
}
